<template>
    <div class="d-content">
    <keep-alive>
    <div class="main-container">
      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
      <div class="employee__heading">
        <h2 class="employee__name">Hello, {{ employeeData.first_name }} {{ employeeData.last_name }}! &#128075; </h2>
        <div class="marquee__container">
          <marquee class="employee__description">Welcome to Paylief self service portal</marquee>
        </div>
      </div>
      <div class="employee__quick__links">
        <div class="employee__quick__box" @click="goToPayslips()">
          <img src="@/assets/mypayslip.svg" alt="">
          <span>My Payslips</span>
        </div>
        <div class="employee__quick__box" @click="goToITstatement()">
          <img src="@/assets/itstatement.svg" alt="">
          <span>My IT Statements</span>
        </div>
        <!-- <div v-if="!releaseItdfForEmployees || proofEmpID == '1fb72c94-ac9a-4fea-9b87-e991dd1f6b71'" class="employee__quick__box" @click="goToITDeclaration(employee_id)">
          <img src="@/assets/itDeclaration.svg" alt="">
          <span>IT Declaration</span>
        </div> -->
        <div v-if="!releaseItdfForEmployees" class="employee__quick__box" @click="goToITDeclaration(employee_id)">
          <img src="@/assets/itDeclaration.svg" alt="">
          <span>IT Declaration</span>
        </div>
        <div v-if="releaseItdfForEmployees || proofEmpID == '1fb72c94-ac9a-4fea-9b87-e991dd1f6b71'"  class="employee__quick__box" @click="goToITProofSubmission(employee_id)">
          <div v-if="this.status=='Open'" style="background-color: green"  class="corner-box">Open Until : {{ this.showDate  }}</div>
          <div v-if="this.status=='Saved as Draft'" style="background-color: orange;"  class="corner-box">Saved as Draft: {{ this.showDate  }}</div>

          <div 
            :style="{ backgroundColor: status === 'Pending From Auditor' ? 'orange' : status === 'IT Proof Submited' ? 'green' : status === 'Closed' ? 'red' : status === 'Opening Soon' ? 'orange' : 'transparent' }" 
            class="corner-box">
            {{ status === 'Pending From Auditor' ? 'Pending for Review' : status === 'IT Proof Submited' ? 'Declaration Locked' : status === 'Closed' ? 'Closed' : status === "Opening Soon" ? 'Opening Soon' : '' }}
          </div>
          <img src="@/assets/itproof.svg" alt="">
          <span>IT Proof Submission</span>
        </div>
        <div v-if="isLeIdMatch" 
        class="employee__quick__box" @click="goToFbpDeclaration(employee_id)">
          <img src="@/assets/fbpdeclaration.svg" alt="">
          <span>FBP Declaration</span>
        </div>
        <div v-if="isLeIdMatch" class="employee__quick__box" @click="goToFbpClaims(employee_id)">
          <img src="@/assets/itDeclaration.svg" alt="">
          <span>FBP Claims</span>
        </div>
      </div>
      <div class="employee__bottom">
        <div class="employee__left">
          <div >
            <img class="profile__img" src="@/assets/default.svg" alt="">
            <img class="shadow__img" src="@/assets/Announcements.png" alt="">
            <p class="employee__profile">Profile</p>
          </div>
          <div class="employee__about">
            <span>{{ employeeData.legalEntityDetails.legalName }}</span>
            <div><span>Name  :</span><span>{{ employeeData.first_name }} {{ employeeData.last_name }}</span></div>
            <div><span>Employee code  :</span><span>{{ employeeData.code }}</span></div>
            <div><span>Date of Joining  :</span><span>  {{ formatToDDMMYYYY(employeeData.date_of_joining) }}</span></div>
            <div><span>Designation  :</span><span> {{employeeData.designation}}</span></div>
            <div><span>Job Location  :</span><span>  {{employeeData.jobLocation}}</span></div>
            <!-- <div v-if="this.le_id!=='e5d057f9-dac4-4fc3-9a31-cdf8d76fbc63'"><span>Reporting To :</span><span>  {{ employeeData.reportingManager }}</span></div> -->
            <!-- <div><span>Cost Center :</span><span>  {{ employeeData.costCenter }}</span></div> -->
          </div>
        </div>
          <div class="employee__center__top">
            <div class="employee__center__left">
              <div class="employee__center__left__top" v-if="!showSpecificTenantIds">
                <p class="employee__compensation">Compensation</p>
                <apexchart v-show="series.length" width="100%" height="90%" style="margin: 30px 5px 20px; text-transform: capitalize;" type="bar" :options="chartOptions" :series="series" :menu="false"></apexchart>
                <div v-show="!series.length" class="noCharts">
                  <img src="@/assets/noCharts.svg" alt="">
                </div>
              </div>
              <div class="employee__center__left__bottom">
                <p class="employee__compensation">Birthdays</p>
                <div class="hl">
                    <div class="bithdaysUl">
                        <span :class="[isClickedYesterday ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(-1)">Yesterday</span>
                        <span :class="[isClickedToday ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(0)">Today</span>
                        <span :class="[isClickedTomorrow ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(1)">Tomorrow</span>
                    </div>
                </div>
                <div class="birthdayContainer">
                    <div class="birthday" >
                        <div class="birthdayBox" v-for=" (item, index) in birthdayList" :key="index" v-show ="birthdayList.length">
                            <div class="birthdayImg">{{item.name.slice(0,1)}}</div>
                            <span class="emojis">&#127874;  &#127881;</span>
                            <p>{{item.name}}</p>
                            <p class="desgn">{{ item.designationName }}</p>
                        </div>
                        <div v-show ="!birthdayList.length" class="noBirthdays">
                          <img src="@/assets/noBirthdays.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="employee__center__right">
              <div class="announcementWrapper">
                <div class="arrow-left" v-show="announcements.length" @click="prevSlide()">
                  <img src="@/assets/leftarrow.svg" alt="" />
                </div>
                <div class="all">
                  <div class="slider" v-for="(item, index) in announcements" v-show="(index) == current" :key="index">
                    <div class="imgContainer">
                      <img class="announcement__img" :src="item.filePath[0]" alt="">
                      <img class="shadow__img" src="@/assets/Announcements.png" alt="">
                    </div>
                    <div class="contentContainer">
                      <p class="contentTitle">{{ item.name }}</p> 
                      <div class="content__div">
                        <p class="contentPara">{{ item.details }}</p>
                        <p class="content__readmore" @click="readMore(item)">Read More</p>
                      </div>
                    </div>
                  </div>
                  <div v-show="!announcements.length" class="noBirthdays">
                    <p>No Announcements Found</p>
                  </div>
                </div>
                <div class="arrow-right" v-show="announcements.length" @click="nextSlide()">
                  <img src="@/assets/rightArrow.svg" alt="" />
                </div>
              </div>
              <div class="announcementHeading">
                <p>Announcements</p>
                <div class="addAnnouncement" @click="showAnnounce()"  v-show="role == 'HR'">
                  <p>+ Add New</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showAnnouncementMore">
              <div class="reportmodal reportcustom-modal">
                <div class="reportmodal-content reportmodal-sm reportmodal-border-radius">
                  <div class="reportmodal-header">
                    <div class="row ">
                      <h3>Announcement</h3>
                    </div>
                    <div>
                      <img src="@/assets/close.png" class="close-img" v-on:click="showAnnouncementMore = false" alt="" />
                    </div>
                  </div>
                  <div class="reportmodal-body">
                    <div class="showAnnouncementMore__img">
                      <img :src="annoucementReadMore.filePath[0]" alt="">
                    </div>
                    <div class="showAnnouncementMore__details">
                      <p>{{ annoucementReadMore.name }}</p>
                      <span>{{ annoucementReadMore.details }}</span>
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
        <div v-if="showAnnouncement">
              <div class="reportmodal reportcustom-modal">
                <div class="reportmodal-content reportmodal-sm reportmodal-border-radius">
                  <div class="reportmodal-header">
                    <div class="row ">
                      <h3>Add Announcement</h3>
                    </div>
                    <div>
                      <img src="@/assets/close.png" class="close-img" v-on:click="showAnnouncement = false" alt="" />
                    </div>
                  </div>
                  <div class="reportmodal-body">
                    <div>
                      <div class="warning__container" v-if="showESSError">
                        <p class="warning" >
                        {{ messageError }}
                      </p>
                      <span class="close" @click="close()">X</span>
                      </div>
                      <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div class="row my-2">
                        <div class="col-12 previewImage" v-for="(image, key) in images" :key="key" v-show="images.length">
                          <img id="preview" class="custom-preview" :ref="'image'" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="my-3 float-right">
                            <span class="post-block-image ml-2" style="cursor: pointer" @click="onPickFile">
                              <img class="celebrate-icon" src="@/assets/feed_gallery.svg" />
                              Photo/GIF
                            </span>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div class="row my-2">
                        <div class="col-12">
                          <textarea class="form-control custom-text" rows="1" name="title" v-model="postform.annoucement"
                            placeholder="Title*" />
                        </div>
                      </div>
                      <div class="row my-2">
                        <div class="col-12">
                          <textarea class="form-control custom-textarea" rows="5" name="description" v-model="postform.details"
                            placeholder="Description*" />
                        </div>
                      </div>
                      <input type="file" multiple accept="image/jpeg" @change="uploadImage" style="display: none" ref="fileInput" />
                      <div class="popup-btns">
                        <btn-grp>
                          <popup-btn text="Cancel" type="secondary" @click="cancel" />
                          <popup-btn text="Save" type="primary" @click="saveAnnouncement" />
                        </btn-grp>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  <pop-up-message v-if="showSuccessMsg" :message="`Save Successfully.`" btnText="OK" @back="goBack"></pop-up-message>
      </div>
    <!-- <div class="in-row">
      <div class="about">
        <div class="rightAbout">
            <div class="empImg">
                <img src="@/assets/Default.svg" alt />
            </div>
            <div class="empAbout">
                <div class="empName">
                    <p>Name : <span>{{ employeeData.first_name }} {{ employeeData.last_name }}</span></p>
                    <p>Employee code : <span>{{ employeeData.code }}</span></p>
                </div>
                <div class="empButton">
                    <button @click="navigateProfile('profile')">My Profile</button>
                    <button @click="navigateProfile('team')">My Teams</button>
                </div>
            </div>
        </div>
        <div class="leftAbout">
            <div class="vl"></div>
            <p>Date of Joining  :<span>  {{ employeeData.date_of_joining }}</span></p>
            <p>Designation      :<span>  {{employeeData.designation}}</span></p>
            <p>Job Location     :<span>  {{employeeData.jobLocation}}</span></p>
            <p>Reporting To     :<span>  {{ employeeData.reportingManager }}</span></p>
        </div>
    </div>
    <div class="holidays">
        <p>Holiday Lists</p>
        <div class="quickLinksHl"></div>
        <div class="holidayWrapper" >
            <div class="holidayContainer" v-for="(items, index) in holidays" :key="index" v-show="!noHolidays">
                <button>
                    {{items.date}}
                </button>
                <p>
                    {{items.details}}
                </p>
            </div>
            <div v-show="!holidays.length" class="noHolidays">
              <p>No Holidays Found</p>
            </div>
        </div>
    </div>
    </div>
    <div class="secondDiv">
        <div class="announcements">
          <div class="announcementHeading">
            <p>Announcements</p>
            <div class="addAnnouncement" @click="showAnnounce()" v-show="role == 'HR'">
              <p>+ Add New</p>
            </div>
          </div>  
            <div class="quickLinksHl"></div>
            <div class="announcementWrapper">
                <div class="arrow-left" v-show="announcements.length" @click="prevSlide()">
                    <img src="@/assets/leftarrow.svg" alt=""/>
                </div>
                <div class="all">
                    <div class="slider" v-for="(item, index) in announcements" v-show="(index) == current" :key="index">
                    <div class="contentContainer">
                        <p class="contentTitle">{{ item.name }}</p>
                        <span class="contentPara">{{ item.details }}</span>
                    </div>
                    <div class="imgContainer">
                        <img :src="item.filePath[0]" alt="">
                    </div>
                </div>
                <div v-show="!announcements.length" class="noBirthdays">
                  <p>No Announcements Found</p>
                </div>
                </div>                
                <div class="arrow-right" v-show="announcements.length" @click="nextSlide()">
                    <img src="@/assets/rightArrow.svg" alt=""/>
                </div>
            </div>
        </div>
        <div class="announcements2">
            <div class="announcementTop">
                <p>Quick Links</p>
                <div class="quickLinksHl"></div>
                <div class="quickLinks">
                  <div class="itDeclaration" @click="goToITDeclaration(employee_id)">
                    <img src="@/assets/itDeclaration.svg" alt="">
                    <p>IT Declaration</p>
                  </div>
                <div class="itDeclaration" @click="goToITProofSubmission(employee_id)">
                    <img src="@/assets/itProof.svg" alt="">
                    <p>IT Proof Submission</p>
                </div> 
                <div class="itDeclaration" @click="goToFbpDeclaration(employee_id)" >
                    <img src="@/assets/helpdesk.svg" alt="">
                    <p>FBP Declaration</p>
                </div>
                <div class="itDeclaration" @click="goToFbpClaims(employee_id)">
                    <img src="@/assets/faq.svg" alt="">
                    <p>FBP Claims</p>
                </div>
                </div>
            </div>
            <div class="announcementBtm">
                <p>Birthdays</p>
                <div class="hl">
                    <div class="bithdaysUl">
                        <span :class="[isClickedYesterday ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(-1)">Yesterday</span>
                        <span :class="[isClickedToday ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(0)">Today</span>
                        <span :class="[isClickedTomorrow ? 'afterLi' : 'bithdaysLi']" @click="navigateDay(1)">Tomorrow</span>
                    </div>
                </div>
                <div class="birthdayContainer">
                    <div class="birthday" >
                        <div class="birthdayBox" v-for=" (item, index) in birthdayList" :key="index" v-show ="birthdayList.length">
                            <div class="birthdayImg">{{item.name.slice(0,1)}}</div>
                            <span class="emojis">&#127874;  &#127881;</span>
                            <p>{{item.name}}</p>
                            <p class="desgn">{{ item.designationName }}</p>
                        </div>
                        <div v-show ="!birthdayList.length" class="noBirthdays">
                          <p>No Birthdays Found</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="showAnnouncement">
              <div class="reportmodal reportcustom-modal">
                <div class="reportmodal-content reportmodal-sm reportmodal-border-radius">
                  <div class="reportmodal-header">
                    <div class="row ">
                      <h3>Add Announcement</h3>
                    </div>
                    <div>
                      <img src="@/assets/close.png" class="close-img" v-on:click="showAnnouncement = false" alt="" />
                    </div>
                  </div>
                  <div class="reportmodal-body">
                    <div>
                      <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div class="row my-2">
                        <div class="col-12 previewImage" v-for="(image, key) in images" :key="key" v-show="images.length">
                          <img id="preview" class="custom-preview" :ref="'image'" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="my-3 float-right">
                            <span class="post-block-image ml-2" style="cursor: pointer" @click="onPickFile">
                              <img class="celebrate-icon" src="@/assets/feed_gallery.svg" />
                              Photo/GIF
                            </span>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div class="row my-2">
                        <div class="col-12">
                          <textarea class="form-control custom-text" rows="1" name="title" v-model="postform.annoucement"
                            placeholder="Title*" />
                        </div>
                      </div>
                      <div class="row my-2">
                        <div class="col-12">
                          <textarea class="form-control custom-textarea" rows="5" name="description" v-model="postform.details"
                            placeholder="Description*" />
                        </div>
                      </div>
                      <input type="file" multiple accept="image/jpeg" @change="uploadImage" style="display: none" ref="fileInput" />
                      <div class="popup-btns">
                        <btn-grp>
                          <popup-btn text="Cancel" type="secondary" @click="cancel" />
                          <popup-btn text="Save" type="primary" @click="saveAnnouncement" />
                        </btn-grp>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
         </div>  -->
    </div>
  </keep-alive>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: {},
  components: {},
  data() {
    return {
      proofEmpID: '',
      status:"",
      releaseItdfForEmployees: false,
      isDisabled: false,
      isLeIdMatch: false,
      leIdsList: ['5d5eadf5-3ec0-4ca1-9c9e-507be4e948f5', 'f333554a-e33f-4466-8088-b7a93f57e6e7', '6c228af4-a9ad-42c2-b688-ae823b386d88', 'f7d8661b-6576-4e53-93ce-24839b192444', 'b97d02db-f2bf-499f-bb85-97c196e297e3', '82ff009f-ade1-415e-806c-e1cb906a88c5', 'e08a4949-6398-4112-b58d-44c2f9d89bd2', '77b22d81-b325-4522-8d8d-fc4a0945896d', '72acf4ce-715b-4fa6-b749-d91607d81686', '6e16e34f-dd51-467f-8618-e04a77694335', '758b6a5d-ad36-4248-9872-cd8ca076ac3a','e5a3995e-52b9-409d-b56e-6d5851faaa78','346579ee-d9b7-47d5-97c5-190b68fdfbaf','3fddf4a5-db13-4d4b-8588-391c6694479d','e418d53f-223e-4eac-a1f5-9799d68a1296','dfba4011-0c5e-46cc-b4f4-99f5962f9ebe','ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0','3c35c1e7-b699-4fc5-9826-7ca9c8b58d9e', '98d4b7fe-9444-4f65-9d12-155eeffab56a', 'e72b1b01-d798-4afd-9b6e-88285d1bbaed', 'b194b460-1197-4304-83e0-60eebe7fe956', 'eeddce5f-655a-4527-8cf1-a408f44fbad7'],
      cropped: null,
      tok:localStorage.getItem("token1"),
      showAnnouncement: false,
      isClickedYesterday: false,
      isClickedToday: true,
      isClickedTomorrow: false,
      noHolidays: true,
      birthdayList: [],
      yesterdayBdayList:[],
      todayBdayList:[],
      tomorrowBdayList:[],
      files: new FormData(),
      images: [],
      postform: {
        annoucement: "",
        details: "",
      },
      announcements: [{filePath:[require('@/assets/defaultAnnouncement1.jpg')], name: "Welcome to Paylief", details: "The Payroll Management System"}, {filePath:[require('@/assets/defaultAnnouncement2.jpg')], name: "Welcome to Paylief", details: "The Payroll Management System"}],
      holidays: [],
      employeeData: null,
      role: "",
      employee_id: "",
      current: 0,      timer: 0,
      planList:[],
      it_plan_id: null,
      file: null,
      showSuccessMsg: false,
      annoucementReadMore: {},
      showAnnouncementMore: false,
      errmsg: "",
      financial_year: '',
      toast: false,
      showESSError: false,
      messageError: "",
      instance: {},
      series: [
        {
            name: 'Earnings',
            data: []
          }, {
            name: 'Deductions',
            data: []
          },
         ],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 300,
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: [ ],
            },
            yaxis: {
              title: {
                text: '₹ (thousands)'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return "₹" + val;
                }
              }
            },
            openUntil:"",
            showDate:"",
            closed:"",
            savedAsDraft:"",
            pendingFromAuditor:"",
            finalSubmission:"",
            todaysDate:"",
            status:"",
            isDeduction6ASave:false,
            isHraSave:false,
            isIncomeLossSave:false,
            isOtherSave:false,
            isPrevEmpSave:false,
            isSec10Save:false,
          },
    };
  },

  mounted() {
    // if (localStorage.getItem('reloaded')) {
    //     // The page was just reloaded. Clear the value from local storage
    //     // so that it will reload the next time this page is visited.
    //     localStorage.removeItem('reloaded');
    // } else {
    //     // Set a flag so that we know not to reload the page twice.
    //     localStorage.setItem('reloaded', '1');
    //     location.reload();
    // }
    this.isDisabled = (localStorage.getItem('le_id') === 'e08a4949-6398-4112-b58d-44c2f9d89bd2') ? true : false;
    this.isLeIdMatch = this.leIdsList ? this.leIdsList.includes(this.le_id) : false;
    this.getItPlan();
    this.play();
    //this.getHolidayList();
    this.getBirthdayList();
    this.getAnnouncements();
    this.getPayrollMonths();
    window.addEventListener('popstate', this.handleBackButton);
    // if (localStorage.getItem('reloaded')) {
    //     // The page was just reloaded. Clear the value from local storage
    //     // so that it will reload the next time this page is visited.
    //     localStorage.removeItem('reloaded');
    // } else {
    //     // Set a flag so that we know not to reload the page twice.
    //     localStorage.setItem('reloaded', '1');
    //     location.reload();
    // }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBackButton);
  },
  activated(){
    this.getItPlan();
    this.play();
    //this.getHolidayList();
    this.getBirthdayList();
    this.getAnnouncements();
    this.getPayrollMonths();
  },
  
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    // le_id() {
    //   if (this.$route.params.entity_index){
    //     return this.getleid(this.$route.params.entity_index);
    //   }
    //   return this.getleid(0);
    // },

    le_id(){
      return localStorage.getItem("le_id")
    },

    empId(){
      return localStorage.getItem("empId")
    },

    showSpecificTenantIds(){
      const le_id = ['dfba4011-0c5e-46cc-b4f4-99f5962f9ebe', 'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0','c020d23c-e664-4c95-9e2d-0e08efd63b40']
      const client_id = this.employeeData.legal_entity_id
      if(le_id.includes(client_id)){
        return true;
      } else{
        return false;
      }
    },

    permanentAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.permanent_address.addressLineOne == null ? "" : this.employeeData.permanent_address.addressLineOne+","} 
         ${this.employeeData.permanent_address.addressLineTwo == null ? "" : this.employeeData.permanent_address.addressLineTwo+","}
         ${this.employeeData.permanent_address.cityName == null ? "" : this.employeeData.permanent_address.cityName+","} 
         ${this.employeeData.permanent_address.stateName == null ? "" : this.employeeData.permanent_address.stateName} 
         ${this.employeeData.permanent_address.pincode == null ? "" : " - "+this.employeeData.permanent_address.pincode}`;
      }
      return "N/A";
    },

    communicationAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.communication_address.addressLineOne == null ? "" : this.employeeData.communication_address.addressLineOne+","} 
         ${this.employeeData.communication_address.addressLineTwo == null ? "" : this.employeeData.communication_address.addressLineTwo+","}
         ${this.employeeData.communication_address.cityName == null ? "" : this.employeeData.communication_address.cityName+","} 
         ${this.employeeData.communication_address.stateName == null ? "" : this.employeeData.communication_address.stateName} 
         ${this.employeeData.communication_address.piactivencode == null ? "" : " - "+this.employeeData.communication_address.pincode}`;
      }
      return "N/A";
    }

  },

  methods: {
    ...mapActions({
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_get_plan:"dashboard/payroll/incometax/getPlan",
      act_getHolidayList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchHolidayList',
      act_getBirthdayList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchBirthdayList',
      act_create: "dashboard/overview/feed/create",
      act_get_announcements: "dashboard/overview/feed/fetchAll",
      act_getPayrollMonthList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthList',
      act_set_it_data:"dashboard/payroll/incometax/setItData",  
      act_set_user_role: "auth/setUserRoleFromProxy",
      getAllItProofSubmissionData: "dashboard/itProof/fetchAll",
    }),


    handleBackButton(event) {
      if(this.tok){
      const token1 = localStorage.getItem("token1") // Admin
      localStorage.setItem('token', token1)
      const userrole1 = localStorage.getItem("userRole1") // Admin
      localStorage.setItem('userRole', userrole1)
      this.act_set_user_role(userrole1);
      const loginId1 = localStorage.getItem("loginId1") // Admin
      localStorage.setItem('loginId', loginId1)
      const employeeId1 = localStorage.getItem("employeeId1") // Admin
      localStorage.setItem('employeeId', employeeId1)
      localStorage.removeItem("le_id")
      localStorage.removeItem("empId")
      setTimeout(() => {
        this.$router.push({ path: `/orgsummary`, replace: true });
        window.location.reload();
      }, 100);
    }
    },

    nextSlide() {
      this.current++;
      if (this.current >= this.announcements.length)
        this.current = 0;
      this.resetPlay();
    },

    prevSlide() {
      this.current--;
      if (this.current < 0)
        this.current = this.announcements.length - 1;
      this.resetPlay();
    },

    resetPlay() {
      clearInterval(this.timer);
      this.play();
    },

    play() {
      let app = this;
      this.timer = setInterval(function() {
        app.nextSlide();
      }, 5000);
    },

    navigateDay(value){
      switch (value) {
        case -1:
          this.birthdayList = this.yesterdayBdayList;
          this.isClickedYesterday = true;
          this.isClickedToday = false;
          this.isClickedTomorrow = false;
          break;
        case 0:
          this.birthdayList = this.todayBdayList;
          this.isClickedYesterday = false;
          this.isClickedToday = true;
          this.isClickedTomorrow = false;
          break; 
        case 1:
          this.birthdayList = this.tomorrowBdayList;
          this.isClickedYesterday = false;
          this.isClickedToday = false;
          this.isClickedTomorrow = true;
          break;
        default:
          break;
      }
    },

    /* function to get file url after edit and upload to the server */
    getFile(event) {
      try {
        this.cropped = event.data.location;
        let file = [{
          filePath: event.data.location
        }]
        this.file = event;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    navigateProfile(value){
      if(value == "profile"){
        this.$router.push({path: `/dashboard/${this.$route.params.entity_index}/myProfile`})
      }
     else{
        this.$router.push({path: `/dashboard/${this.$route.params.entity_index}/myTeamMembers`})
      }
    },

    close(){
        this.showESSError = false;
    },

    readMore(item){
      this.annoucementReadMore = item;
      this.showAnnouncementMore = true;
    },

    async getEmployeeData() {
      try {
        let bodyParams = {};
        // let  data = await this.getOrgLeList({
        //   data: {
        //       ...bodyParams
        //   }
        //});
        //this.role = data.data.user.userRole;
        //this.employee_id = data.data.user.employee_id;
        //this.getItPlan();
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        this.employeeData.dob = new Date(this.employeeData.dob).toISOString().slice(0, 10);
        this.employeeData.date_of_joining = this.employeeData.date_of_joining;
        // this.postLock();
        this.proofEmpID = response.data.payload[0].id
        this.financial_year = response.data.payload[0].payrollDetails.year
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    showAnnounce(){
      this.showAnnouncement = true;
      this.postform.annoucement = "";
      this.postform.details= "";
      this.images = [];
    },

    formatToDDMMYYYY(isoString) {
      const date = new Date(isoString);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },

    truncateString(str, num) {
      return str;
    },

    // async getHolidayList() {
    //   try {
    //     let obj ={
    //       employee_id : this.empId,
    //     }
    //     let res = await this.act_getHolidayList(obj);
    //     if(res.data.payload !== null){
    //       this.noHolidays = false;
    //       this.holidays = res.data.payload.holidays;
    //     }
    //   } catch (error) {
    //       this.toast = true;
    //       this.errmsg = error;
    //   }
    // },

    async getBirthdayList() {
      try {
        let obj ={
          employee_id : this.empId,
          le_id: this.le_id
        }
        let res = await this.act_getBirthdayList(obj);
        if(res.data && res.data.payload){
          this.yesterdayBdayList = res.data.payload[0].yest;
          this.todayBdayList = res.data.payload[0].today;
          this.birthdayList = this.todayBdayList;
          this.tomorrowBdayList = res.data.payload[0].tmrw;
        }else{
          this.noHolidays = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      }
    },

    async getAnnouncements() {
      try {
        let res = await this.act_get_announcements(this.le_id);
        if (res.data.payload.length) {
          this.announcements.push(...res.data.payload);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    cancel() {
      this.showAnnouncement = false;
    },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        this.images = [];
        this.images.push(selectedFiles[i]);
        this.files.set("file", selectedFiles[i]);
        this.files.set("fileType", selectedFiles[i].type);
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.$refs.image[i].src = reader.result;
        };
        reader.readAsDataURL(this.images[i]);
      }  
    },

    async saveAnnouncement() {
      try {
        this.$root._data.isSaving = true;
        this.files.set("le_id", this.le_id);
        this.files.set("details", this.postform.details);
        this.files.set("annoucement", this.postform.annoucement);
        let res = await this.act_create(this.files);
        if (res.data.payload.length > 0) {
          //const data = [...this.postList];
          // data.push(res.data.payload);
          // this.postList = data;
          // this.fetchAll();
          setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
          this.showESSError = true;
          this.messageError = res.data.payload[0].message;
        } else{
          this.getAnnouncements();
          setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
          this.showSuccessMsg = true;
        }
      } catch (error) {
        this.showESSError = true;
        this.$root._data.isSaving = false;
      }
    },

    async getPayrollMonths() {
      try {
        let obj ={
          emp_id : this.empId,
          le_id: this.le_id
        }
        let payrollMonths = [];
        let months = [];
        let earnings = [];
        let deductions = [];
        let res = await this.act_getPayrollMonthList(obj);
        let payrollData = res.data.payload;
        if (res.data && res.data.payload) {
          let mergedArray = [];
          const objectKeys = Object.keys(payrollData).reverse();
          for (let key of objectKeys) {
            mergedArray.push(...payrollData[key]);
          }

          let month = '';
          let monthEarning = '';
          let monthDeductions = '';
          let tempArr = []
          for (const obj of mergedArray) {
            const fiscalYear = obj.fy;

            // Iterate through the properties of the object
            for (const key in obj) {
              if (key !== 'fy') {
                const monthData = obj[key];
                monthEarning = monthData && monthData.earnings && monthData.earnings.total;
                earnings.push(monthEarning);
                monthDeductions = monthData && monthData.deductions && monthData.deductions.total;
                deductions.push(monthDeductions);
                month = `${monthData.month}-${fiscalYear}`;
                months.push(month);

              }
            }
          }
        }
      // months = months.filter(value => value !== null && value !== undefined);
      earnings = earnings.filter(value => value !== null && value !== undefined);
      deductions = deductions.filter(value => value !== null && value !== undefined);
      months = months.slice(0, earnings.length);
      if (months.length > 6) {
        this.chartOptions.xaxis.categories = months.slice(0,6);
        this.series[0].data = earnings.slice(0,6);
        this.series[1].data = deductions.slice(0,6);
      } else {
        this.chartOptions.xaxis.categories = months;
        this.series[0].data = earnings;
        this.series[1].data = deductions;
      }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      }
    },

    goBack(){
      this.showSuccessMsg = false;
      this.showAnnouncement = false;
    },

     navigateToPf(url){
         this.$router.push({
        path:url
          });
      },
    
    async getItPlan() {
      try {
        await this.getEmployeeData();
        let res = await this.act_get_plan(this.empId)
        this.planList = res.data.payload.filter( ele => ele.is_plan_active == true);
        this.it_plan_id = this.planList[0] && this.planList[0].id;
        this.getItProof();
        if(this.it_plan_id){
          this.fetchRecord();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      } 
    },

    async fetchRecord() {
        this.instance.employee_id = this.empId;
        this.instance.financial_year = this.financial_year;
        this.instance.it_plan_id=this.it_plan_id;
        this.instance.le_id=this.le_id;
      let res = await this.act_set_it_data(this.instance)
      let isDeclared = res.data.payload.itDeclarationStatus;
      sessionStorage.setItem('isDeclared', isDeclared);
    },

    goToITDeclaration() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
      })
      // let declared = sessionStorage.getItem('isDeclared');
      // if(declared == 'true'){
      //   this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
      // });
      // }else{
      //   this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclarationDashboard`,
      // });
      // }
      
      //window.location.reload();
      //path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
      //payroll/incometaxdeclarationplan
    },

    goToITProofSubmission(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/itProofSubmission`,
        query: { it_plan_id:this.it_plan_id, employee_id: rec }
      });
      //path: `/dashboard/${this.$route.params.entity_index}/mysalary/itProofSubmission`,
      ///payroll/incometaxproofplan
    },
       goToFbpDeclaration(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/fbpDeclarationEss`,
        query: { id: rec }
      });
    },
       goToFbpClaims(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/fbpClaimsEss`,
        query: { id: rec }
      });
    },

    goToPayslips(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/payrollReports`,
      });
    },

    goToITstatement(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/payrollReports`,
      });
    },
    getTodaysDate() {
          const today = new Date();
          const yyyy = today.getFullYear();
          const mm = String(today.getMonth() + 1).padStart(2, '0');
          const dd = String(today.getDate()).padStart(2, '0');
          return `${yyyy}-${mm}-${dd}`;
        },

    async getItProof(){
      const itsheetPayload = {
          employeeId: this.empId,
          le_id: this.le_id,
          financialYear:2025,
          itPlanId: this.it_plan_id,
        };
        let result = await this.getAllItProofSubmissionData(itsheetPayload);
        if (!result.releaseITProof) {
          this.releaseItdfForEmployees = false  
        } else if(result.releaseITProof==null) {
          this.releaseItdfForEmployees = false
        } else {
          this.releaseItdfForEmployees = true
        }
        this.openUntil = result.submissionStartDate;
        this.closed = result.submissionEndDate;
        this.showDate = this.closed.split('-').reverse().join('-');
        this.pendingFromAuditor = result.isAuditValidated;
        this.finalSubmission= result.itProofSubmitted;
        this.isDeduction6ASave = result.isDeduction6ASave?result.isDeduction6ASave : false;
        this.isHraSave = result.isHraSave;
        this.isIncomeLossSave = result.isIncomeLossSave;
        this.isOtherSave = result.isOtherSave;
        this.isPrevEmpSave = result.isPrevEmpSave;
        this.isSec10Save = result.isSec10Save;        
        this.todaysDate = this.getTodaysDate();
       if(this.todaysDate<= this.closed){
        if(this.isHraSave == true || this.isIncomeLossSave == true || this.isOtherSave == true || this.isPrevEmpSave == true || this.isSec10Save== true || this.isDeduction6ASave == true ){
          if(this.isHraSave == true && this.isIncomeLossSave == true && this.isOtherSave == true  && this.isSec10Save== true && this.isDeduction6ASave == true&& this.pendingFromAuditor == true ){
            if(this.pendingFromAuditor == true){
              if(this.finalSubmission == true){
                this.status = "IT Proof Submited"
              }             
            }
        }
        else if(this.finalSubmission == true && this.pendingFromAuditor == false ){
          this.status = "Pending From Auditor"
        }
        else{
          this.status = "Saved as Draft"
        }
        }     
        else{
          this.status = "Open"
        }
       }
       else {
        if(this.le_id == "dfba4011-0c5e-46cc-b4f4-99f5962f9ebe" || this.le_id == "a5d421ae-b986-4ec0-ad64-f6eed8d5b3cb"){
          this.status = "Opening Soon"
        }else{
          this.status = "Closed"
        }
       }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;500;700&display=swap');
  // .employee__heading{
  //   margin-top: 40px;
  // }
  .employee__name{
    color: #376cd3;
    margin-bottom: 10px;
    font-family: 'poppins', sans-serif;
  }

  .marquee__container{
    width: 100%;
    height: 50px;
    border-radius: 6px;
    background-color: #f2f2f2;
    padding: 14px 0;
  }

  .employee__description{
    color: #777777;
    font-weight: 500;
    font-size: 1.2rem;
    font-family: 'poppins', sans-serif;
  }

  .employee__quick__links{
    display: flex;
    align-items: center;
    gap: 25px;
    margin-top: 30px;
    flex-wrap: wrap;
  }

  .employee__quick__box{
    position: relative;
    display: flex;
    flex: 1;
    height: 130px;
    min-width: 110px;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px 5px 10px;
    background-color: #F1F6F9;
    border: 1.5px solid #EAEAEA;
    border-radius: 5px;
    box-shadow: 0px 1px 2px #f0f0f0;
    cursor: pointer;
    justify-content: flex-start;
  }

  .employee__quick__box:hover{
    transform: scale(1.05);
    transition:all 0.5s ease-in-out;
    border: 1px solid #34C0BD;
  }

  .employee__quick__box > img {
    width: 50px;
    height: 50px;
  }

  .employee__quick__box > span{
    margin: 20px 0 10px;
    color: #777777;
    font-weight: bold;
    font-family: 'poppins', sans-serif;
  }
  .corner-box {
  align-self: flex-end;
  margin-top: -10px; 
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 3px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

  .employee__bottom{
    margin-top: 25px;
    display: flex;
    gap: 25px;
    //align-items: center;
  }
  
  .employee__left{
    display: flex;
    flex-direction: column;
    background-color: #fcfcfc;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    box-shadow: 0px 1px 2px #f0f0f0;
    width: 25%;
  }

  .employee__left > div{
    width: 100%;
    position: relative;
  }

  .profile__img{
    width: 100%;
    height: 220px;
    object-fit: cover;
  }

  .employee__profile{
    position: absolute;
    top: 20px;
    left: 20px;
    font-weight: bold;
    color: #ffffff;
    font-size: 1.1rem;
  }

  .employee__compensation{
    position: absolute;
    top: 20px;
    left: 20px;
    font-weight: bold;
    color: #376cd3;
    font-size: 1.1rem;
  }

  .shadow__img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
  }

  .employee__about{
    padding: 15px 18px;
    display: flex;
    flex-direction: column;
    //height: 350px;
    align-items: flex-start;
    justify-content: space-around;
  }

  .employee__about > span {
    font-weight: 500;
    align-self: center;
    font-size: 1.2rem;
    color: #444444;
    padding-bottom: 5px;
  }

  .employee__about > div{
    width: 100%;
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .employee__about > div > :first-child {
    color: #777777;
    //font-size: 1rem;
    font-weight: bold;
    font-family: 'poppins', sans-serif;
    min-width: 130px;
  }

  .employee__about > div > :last-child{
    color: #444444;
    font-weight: bold;
    font-family: 'poppins', sans-serif;
  }

  .employee__center{
    width: 75%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .employee__center__top{
    width: 75%;
    display: flex;
    gap: 25px;
  }

  .employee__center__left{
    width: 48%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    // background-color: #fcfcfc;
    // border: 1px solid #eeeeee;
    // border-radius: 5px;
    // box-shadow: 0px 1px 2px #f0f0f0;
    //box-shadow: 0px 1px 22px -12px #607d8b;
    color: #376cd3;
    font-weight: 500;
  }

  .employee__center__left__top{
    width: 100%;
    height: 50%;
    background-color: #fcfcfc;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    box-shadow: 0px 1px 2px #f0f0f0;
    position: relative;
  }

  .employee__center__left__bottom {
    width: 100%;
    height: 50%;
    background-color: #fcfcfc;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    box-shadow: 0px 1px 2px #f0f0f0;
    position: relative;
    display: flex;
  }

  .hl{
    height: 40px;
    width: 100%;
    background-color: #F1F6F9;
    position: absolute;
    top: 50px;
    padding: 0 1px;
    left: 0;
    right: 0;
    margin: auto;
}

.bithdaysUl{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    margin-bottom: 30px;
}

.birthdayContainer{
    // margin-top: 30px;
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    padding: 20px;
}

.birthday{
    display: flex;
    align-items: flex-end;
    min-height: 164px;
    //justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 20px;
    overflow-y: hidden;
    overflow-x: auto;
}

.birthday::-webkit-scrollbar {
    display: none;
}
.birthdayBox{
    display: flex;
    align-items:flex-start;
    justify-content: flex-end;
    min-width: 190px;
    height: 90px;
    color: #376cd3;
    font-weight: 500;
    //padding: 0 20px;
    background-color: #F1F6F9;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    flex-direction: column;
    // gap: 20px;
    // cursor: pointer;
}

.birthdayBox > p{
    margin: 0;
    padding: 0 8px 8px 8px;
    font-size: 0.9rem;
    color: #444444;
}

.birthdayBox .desgn{
    color: #376cd3;

}

.birthdayImg{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    font-size: 1.4rem;
    background-color: #a3a2a2;
    color: #ffffff;
    font-weight: bold;
    position: absolute;
    left: 20px;
    top: -18px;
}

.emojis{
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 25px;
}

.bithdaysLi {
    cursor: pointer;
    font-size: 1rem;
    color: #777777;
    font-weight: 500;
}

.afterLi{
    cursor: pointer;
    font-size: 1rem;
    color: #376cd3;
    font-weight: bold;
    position: relative;
}


  .data__ess{
    margin-top: 20px;
    margin-left: 20px;
    width: 90%;
    height: 100%;
    object-fit: contain;
  }

  .employee__center__right{
    width: 55%;
    height: 510px;
    background-color: #fcfcfc;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    box-shadow: 0px 1px 2px #f0f0f0;
    //box-shadow: 0px 1px 22px -12px #607d8b;
    position: relative;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .announcementWrapper{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
}

.all{
    height: 100%;
    width: 100%;
    display: flex;
    overflow: hidden;
}
.slider{
    height: 100%;
    width: 100%;
    transition: all 0.3s ease-in-out;
}

.imgContainer{
    height: 85%;
    width: 100%;
    position: relative;
}

.contentContainer{
    width: 100%;
    height: 25%;
    color: #444444;
    padding: 10px;
    
}

.contentTitle{
    color: #444444;
    font-size: 1rem;
    width: 75%;
    font-weight: bold;
    font-family: 'poppins', sans-serif;
    margin-bottom: 10px;
   // white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 1; 
           line-clamp: 1;
   -webkit-box-orient: vertical;
}

.content__div{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
}

.content__readmore{
  color: #376cd3;
  cursor: pointer;
}

.content__readmore:hover{
  text-decoration: underline;
}

.contentPara{
    color: #777777;
    //height: 50px;
    width: 80%;
  overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 1; 
           line-clamp: 1;
   -webkit-box-orient: vertical;
}

.announcement__img {
    height: 100%;
    width: 100%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    object-fit: cover;
}

.announcementHeading > p{
    position: absolute;
    top: 20px;
    left: 20px;
    color: #ffffff;
    font-weight: bold;
    font-size: 1.2rem;
    font-family: 'poppins', sans-serif;
  }

  .addAnnouncement{
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .addAnnouncement > p{
    margin: 0;
    font-size: 1.2rem;
    color: #ffffff;
    font-weight: bold;
    min-width: max-content;
    font-family: 'poppins', sans-serif;
  }

  .arrow-left{
    z-index: 1;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 35%;
    bottom: 0;
    left: 0px;
    cursor: pointer;
    opacity: 0.8;
}

.arrow-left > img,
.arrow-right > img {
  width: 100%;
  object-fit: cover;
}

.arrow-right{
    z-index: 1;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 35%;
    bottom: 0;
    right: 0px;
    cursor: pointer;
    opacity: 0.8;
}

.reportcustom-modal {
        &.reportmodal {
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            z-index: 6;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background-color: rgba(0, 0, 0, 0.3);
        }

        /* Modal Content */
        .reportmodal-content {
            background-color: white;
            z-index: 20;
            border-radius: 8px;
            min-width: 60%;
            &.reportmodal-md {
                width: 760px;
            }

            &.reportmodal-sm {
                width: 488px;
            }

            .reportmodal-header {
                display: flex;
                align-items: center;
                height: 50px;
                padding: 20px;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                border: solid 1px #F0F0F0;
                background-color: #ffffff;

                h3 {
                    font-weight: 600;
                    color: #34C0BD;
                }
            }

            .modal-footer {
                padding: 15px;
                text-align: right;
                border-top: 1px solid #34C0BD;
            }
        }
    }

    .custom-text{
      width: 100%;
      height: 40px;
    }

        .custom-textarea {
          width: 100%;
        }

        .post-block-image {
  background: #f3f3f3;
  padding: 10px 12px 9px 10px;
  border-radius: 20px;
  color: #7f66b2;
  font-weight: 500;
}

img.celebrate-icon {
  width: 25px;
  margin-right: 10px;
  transform: translate(0px, 6px);
}

.popup-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px 20px;

}

.previewImage{
  height: 150px;
  width: 100px;
  object-fit:cover;
}

.previewImage > img{
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.warning__container{
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  min-height: 45px;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.warning__container > span{
  cursor: pointer;
}

.warning {
  color: #ca2c39;
  margin: 0;
  font-weight: bold;
}

.disabled-div {
  pointer-events: none;
  opacity: 0.5; /* Make it look disabled */
}

.showAnnouncementMore__img{
  width: 100%;
  height: 400px;
  padding: 40px 60px;
}

.showAnnouncementMore__img > img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.showAnnouncementMore__details{
  padding: 0 60px 30px;
}

.showAnnouncementMore__details > p{
  color: #376cd3;
  font-weight: bold;
}

.showAnnouncementMore__details > span{
  color: #444444;
  font-weight: 500;
}

.noBirthdays{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .noCharts{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

// .employee__center__bottom{
//   width: 100%;
//   background-color: #fcfcfc;
//   border: 1px solid #eeeeee;
//   border-radius: 5px;
//   padding: 30px;
//   box-shadow: 0px 1px 2px #f0f0f0;
//   position: relative;
//   display: flex;
//   align-items: flex-start;
//   justify-content: center;
//   height: 65px;
//   flex-direction: column;
//   position: relative;
// }

// .employee__center__bottom > span{
//   color: #376cd3;
//   font-weight: 500;
//   font-size: 1.2rem;
// }
</style>
<!-- <style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

.profile {
  width: 100%;
  height: auto;
  border: 1px solid #efefef;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #efefef;
  padding: 15px;
  margin-bottom: 30px;
}

.attribute-value {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6px 5px 0px 5px;
  *:nth-child(2n) {
    font-weight: 600;
  }
}

.image {
  width: 100%;
  background-color: #f4f4f4;
}


.in-row {
  display: flex;
  gap: 30px;
  padding: 10px 15px;
  //flex-wrap: wrap;
  margin-bottom: 20px;
}
.about {
    flex: 2.5;
    //height: 268px;
    background-color: #f5f5f5;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    display: flex;
  }

  .holidays{
    flex: 1;
    height: 268px;
    padding: 20px 30px 5px 30px;
    background-color: #f5f5f5;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .holidays > p{
    font-size: 1.1rem;
    color: #376cd3;
    font-weight: bold;
  }

  .holidayhl{
    border-top: 2px solid #34C0BD;
    width: 100%;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .holidayWrapper{
    display: flex;
    overflow-x: hidden;
    overflow-y: auto;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    height: 100%;
    padding: 10px 0 15px 0;
    margin-top: 5px;
  }

  .holidayWrapper::-webkit-scrollbar {
    width: 5px;
    padding-bottom: 100px;
  }

  .holidayWrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}

.holidayWrapper::-webkit-scrollbar-thumb {
  background: #376cd3; 
  border-radius: 10px;
}

  .holidayContainer{
    display: flex;
    width: 100%;
    gap: 25px;
    align-items: center;
  }

  .holidayContainer > button {
    padding: 15px 25px 15px 25px;
    background-color: #EFFFFF;
    font-size: 1rem;
    border-radius: 5px;
    color: #34C0BD;
    font-weight: bold;
  }

  .holidayContainer > p{
    margin: 0;
    font-size: 1rem;
    color: #777777;
    font-weight: bold;
  }

  .noHolidays{
    align-self: start;
    font-size: 1.2rem;
    color: #444444;
    font-weight: 500;
  }

  .noBirthdays{
    align-self: start;
    margin-top: 20px;
    font-size: 1.2rem;
    color: #444444;
    font-weight: 500;
  }

  .secondDiv{
    display: flex;
    padding: 0 15px 0 15px;
    gap: 30px;
  }

  .announcements{
    width: 60%;
    height: 540px;
    padding: 20px 30px 20px 30px;
    background-color: #f5f5f5;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .announcementHeading{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .addAnnouncement{
    cursor: pointer;
  }

  .addAnnouncement > p{
    margin: 0;
    font-size: 1.2rem;
    color: #34C0BD;
    font-weight: bold;
    min-width: max-content;
  }

  .announcementHeading > P{
    color: #376cd3;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 8px;
  }
  .announcements2{
    width: 40%;
    height: 540px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 30px;
  }

  .announcementTop{
    height: 215px;
    padding: 20px 30px 20px 30px;
    background-color: #f5f5f5;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    // display: flex;
    // flex-direction: column;
  }

  .quickLinks{
    display: flex;
    height: 144px;
    width: 100%;
    padding: 35px 0 20px 0;
    justify-content: space-between;
  }

  .itDeclaration{
    display: flex;
    width: 23%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 20px;
    cursor: pointer;
  }

  .itDeclaration > img {
    height: 60px;
    width: 60px;
  }

  .itDeclaration > p{
    font-size: 1rem;
    font-weight:500;
    margin: 0;
  }

  .itDeclaration:hover{
    color: #376cd3;
  }

  .quickLinksHl{
    border-top: 2px solid #34C0BD;
    width: 100%;
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .announcementTop > p{
    color: #376cd3;
    font-weight: bold;
    font-size: 1.1rem;
  }
  .announcementBtm{
    height: 295px;
    width: 712px;
    background-color: #f5f5f5;
    border: 1px solid #F0F0F0;
    padding: 20px 30px 20px 30px;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 50px;
  }

  .announcementBtm > p {
    color: #376cd3;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .rightAbout{
    display: flex;
    //height: 268px;
    padding: 30px;
  }

  .leftAbout{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: 55px 0 55px 45px;
  }

  .leftAbout > p {
    font-weight: bold;
    color: #777777;
    font-size: 1rem;
  }

  .leftAbout > p > span{
    color: #444444;
    text-align: end;
  }
  .empImg{
    margin-right: 30px;
    width: 200px;
    // height: 218px;
    border-radius: 10px;
    
  }
  .empName{
    margin-top: 25px;
    margin-bottom: 20px;
  }

  .empName > p {
    color: #777777;
    font-weight: bold;
    font-size: 1rem;
  }

  .empName > p > span {
    color: #444444;
  }

  .empAbout{
    display: flex;
    flex-direction: column;
    height: auto;
    //margin: 0 30px 30px 0;
  }

  .empButton{
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    gap: 12px;
  }

  .empButton > button {
   // width: 279px;
    //height: 40px;
    padding: 10px 110px 10px 110px;
    background-color: #34C0BD;
    border-radius: 5px;
    color: #f5f5f5;
    font-weight: bold;
  }

  .empButton > button:hover{
    transform: scale(1.05);
    transition:all 0.5s ease-in-out;
  }


  .vl {
  border-left: 2px solid #34C0BD;
  height: 80%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.hl{
    height: 40px;
    width: 100%;
    background-color: #EFFFFF;
    position: absolute;
    top: 55px;
    padding: 0 1px;
    left: 0;
    right: 0;
    margin: auto;
}

.bithdaysUl{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    margin-bottom: 30px;
}

// .bithdaysUl > li {
//     cursor: pointer;
//     font-size: 16px;
//     color: #444444;
//     font-weight: 500;
// }

.bithdaysLi {
    cursor: pointer;
    font-size: 1rem;
    color: #444444;
    font-weight: bold;
}

.afterLi{
    cursor: pointer;
    font-size: 1rem;
    color: #376cd3;
    font-weight: bold;
    position: relative;
}


// .bithdaysUl > li::after{
//     content: "";
//     height: 1px;
//     width: 100%;
//     color: #376cd3;
// }



.announcementWrapper{
    width: 100%;
    height: 90%;
    position: relative;
}

.arrow-left{
    z-index: 1;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 240px;
    bottom: 0;
    left: -10px;
    cursor: pointer;
    opacity: 0.8;
}

.arrow-right{
    z-index: 1;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 240px;
    bottom: 0;
    right: -10px;
    cursor: pointer;
    opacity: 0.8;
}

.all{
    height: 100%;
    width: 100%;
    display: flex;
    overflow: hidden;
}
.slider{
    height: 100%;
    width: 100%;
    transition: all 0.3s ease-in-out;
}

.imgContainer{
    height: 82%;
    width: 100%;
    position: relative;
}

.contentContainer{
    height: 80px;
    color: #444444;
}

.contentTitle{
    color: #444444;
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 10px;
}

.contentPara{
    color: #575555;
    height: 50px;
    width: 95%;
    font-size: 1rem;
    font-weight: 500;
    //overflow: hidden;
    text-overflow: ellipsis;
    //white-space: nowrap;
}

img {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
}

.birthdayContainer{
    // margin-top: 30px;
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
}

.birthday{
    display: flex;
    align-items: flex-end;
    min-height: 164px;
    //justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 10px;
    overflow-y: hidden;
    overflow-x: auto;
}

.birthday::-webkit-scrollbar {
    display: none;
}
.birthdayBox{
    display: flex;
    align-items:flex-start;
    justify-content: flex-end;
    min-width: 250px;
    height: 110px;
    color: #376cd3;
    font-weight: 500;
    //padding: 0 20px;
    background-color: #ffffff;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #F0F0F0;
    position: relative;
    flex-direction: column;
    // gap: 20px;
    // cursor: pointer;
}

.birthdayBox > p{
    margin: 0;
    padding: 0 10px 10px 20px;
    font-size: 1rem;
    color: #444444;
}

.birthdayBox .desgn{
    color: #376cd3;

}

.birthdayImg{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    font-size: 1.4rem;
    background-color: #a3a2a2;
    color: #ffffff;
    font-weight: bold;
    position: absolute;
    left: 30px;
    top: -25px;
}

.emojis{
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 30px;
}

.reportcustom-modal {
        &.reportmodal {
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            z-index: 6;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background-color: rgba(0, 0, 0, 0.3);
        }

        /* Modal Content */
        .reportmodal-content {
            background-color: white;
            z-index: 20;
            border-radius: 8px;
            min-width: 60%;
            &.reportmodal-md {
                width: 760px;
            }

            &.reportmodal-sm {
                width: 488px;
            }

            .reportmodal-header {
                display: flex;
                align-items: center;
                height: 50px;
                padding: 20px;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                border: solid 1px #F0F0F0;
                background-color: #ffffff;

                h3 {
                    font-weight: 600;
                    color: #34C0BD;
                }
            }

            .modal-footer {
                padding: 15px;
                text-align: right;
                border-top: 1px solid #34C0BD;
            }
        }
    }

    .custom-text{
      width: 100%;
      height: 40px;
    }

        .custom-textarea {
          width: 100%;
        }

        .post-block-image {
  background: #f3f3f3;
  padding: 10px 12px 9px 10px;
  border-radius: 20px;
  color: #7f66b2;
  font-weight: 500;
}

img.celebrate-icon {
  width: 25px;
  margin-right: 10px;
  transform: translate(0px, 6px);
}

.popup-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px 20px;

}

.previewImage{
  height: 100px;
  width: 100px;
  object-fit:cover;
}

@media only screen and (max-width: 1600px) {

  .about{
    flex: 2.5;
  }

  .holidays{
    flex: 1;
    height: 225px;
  }

  .holidays > p{
    font-size: 1.3rem;
  }
  .empImg{
    margin-right: 15px;
    width: 160px;
    height: 160px;
    // height: 218px;
    border-radius: 10px;
  }

  .empName{
    margin-top: 0px;
    margin-bottom: 14px;
  }

  .empName > p {
    font-size: 0.9rem;
  }

  .leftAbout > p {
    font-size: 0.9rem;
  }

  .empButton > button {
   // width: 279px;
    //height: 40px;
    font-size: 0.9rem;
    padding: 10px 50px 10px 50px;
  }

  .leftAbout{
    padding: 35px 0 35px 20px;
  }

  .holidayContainer > button {
    padding: 12px 10px 12px 10px;
    background-color: #EFFFFF;
    font-size: 0.9rem;
    border-radius: 5px;
    color: #34C0BD;
    font-weight: bold;
  }

  .holidays > p{
    font-size: 1.1rem;
  }

  .holidayContainer > p{
    margin: 0;
    font-size: 0.9rem;
    color: #777777;
    font-weight: bold;
  }

  .holidayWrapper{
    gap: 10px;
  }

  .announcementTop{
    padding: 20px;
  }

  .announcements{
    min-width: 550px;
  }

  .announcements > p {
    font-size: 1.1rem;
  }

  .contentTitle{
    font-size: 1.1rem;
  }

  .announcements2{
    max-width: 480px;
  }

  .announcementTop{
    width: 100%;
  }

  .announcementTop > p{
    font-size: 1.1rem;
  }

  .announcementBtm{
    width: 100%;
  }

  .announcementBtm > p{
    font-size: 1.1rem;
  }

  .quickLinks{
    width: 100%;
  }
  

  // .itDeclaration{
  //   width: min-content;
  // }

  .itDeclaration > img{
    height: 40px;
    width: 40px;
  }

  .birthdayBox{
    min-width: 210px;
  }

  .birthdayBox > p{
    font-size: 1rem;
  }

  .birthdayImg{
    font-size: 1.4rem;
    height: 46px;
    width: 46px;
    position: absolute;
    left: 25px;
    top: -23px;
  }

}
</style> -->
